import router from '@/modules/domainManagement/router'
export default {
  router,
}
